export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      products: "Our Products",
      booking: "Book Now",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      badge: "Event Equipment Rentals",
      title: "Make Your Event",
      titleHighlight: "Unforgettable",
      subtitle: "Premium chairs, tables, and bouncy castles for weddings, parties, and corporate events. Easy booking, reliable service.",
      browseBtn: "Browse Rentals",
      contactBtn: "Contact Us",
      startingFrom: "Starting from",
      bestValue: "Best Value",
    },
    // Features Section
    features: {
      title: "Why Choose Us",
      subtitle: "Everything you need for a successful event",
      items: [
        { title: "Premium Quality", description: "Top-tier equipment maintained to the highest standards for your special occasions." },
        { title: "Easy Booking", description: "Simple online booking with real-time availability and instant confirmation." },
        { title: "Reliable Delivery", description: "On-time delivery and pickup, so you can focus on your event." },
      ],
    },
    // Equipment Section
    equipment: {
      title: "Our Equipment",
      subtitle: "Everything you need for a perfect event",
      viewAll: "View All",
      categories: {
        chairs: { title: "Chairs", description: "Elegant seating options" },
        tables: { title: "Tables", description: "Various sizes available" },
        bouncy_castles: { title: "Bouncy Castles", description: "Fun for all ages" },
      },
    },
    // How It Works Section
    howItWorks: {
      title: "How It Works",
      subtitle: "Simple steps to your perfect event",
      steps: [
        { step: "1", title: "Browse & Select", description: "Explore our collection and choose what you need" },
        { step: "2", title: "Pick Your Dates", description: "Select your rental period and check availability" },
        { step: "3", title: "We Deliver", description: "We bring everything to your venue on time" },
      ],
    },
    // CTA Section
    cta: {
      title: "Ready to Make Your Event Special?",
      subtitle: "Browse our selection and book your rentals today",
      button: "Start Booking",
    },
    // Products Page
    products: {
      title: "Our Products",
      subtitle: "Quality equipment for every event",
      allCategories: "All",
      chairs: "Chairs",
      tables: "Tables",
      bouncyCastles: "Bouncy Castles",
      perDay: "/day",
      available: "available",
      bookNow: "Book Now",
    },
    // Booking Page
    booking: {
      title: "Book Your Rentals",
      subtitle: "Fill out the form below to request your rental items",
      // Form sections
      rentalPeriod: "Rental Period",
      startDate: "Start Date",
      endDate: "End Date",
      selectItems: "Select Items",
      quantity: "Qty",
      customerInfo: "Your Information",
      name: "Full Name",
      namePlaceholder: "Enter your full name",
      email: "Email Address",
      emailPlaceholder: "your@email.com",
      phone: "Phone Number",
      phonePlaceholder: "(555) 123-4567",
      deliveryAddress: "Delivery Address",
      deliveryAddressPlaceholder: "Enter full delivery address",
      eventSchedule: "Event Schedule",
      eventStart: "Event Start Time",
      eventEnd: "Event End Time",
      logistics: "Delivery & Pickup",
      earliestDelivery: "Earliest Delivery Time",
      latestPickup: "Latest Pickup Time",
      specialRequests: "Special Requests (Optional)",
      specialRequestsPlaceholder: "Any special requirements or notes...",
      // Summary
      orderSummary: "Order Summary",
      rentalDays: "days",
      subtotal: "Subtotal",
      deliveryPickupFee: "Delivery/Pickup Fee",
      total: "Total",
      submitBooking: "Submit Booking Request",
      // Messages
      selectDates: "Please select rental dates first",
      noItemsSelected: "No items selected",
      addItems: "Add items to see pricing",
      // Validation
      required: "This field is required",
      invalidEmail: "Please enter a valid email",
      invalidPhone: "Please enter a valid phone number",
      // Success
      successTitle: "Booking Submitted!",
      successMessage: "Thank you for your booking request. We'll review it and get back to you shortly via email.",
      bookAnother: "Book Another",
    },
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "We'd love to hear from you",
      getInTouch: "Get in Touch",
      visitUs: "Visit Us",
      callUs: "Call Us",
      emailUs: "Email Us",
      sendMessage: "Send us a Message",
      name: "Your Name",
      namePlaceholder: "Enter your name",
      email: "Email Address",
      emailPlaceholder: "your@email.com",
      phone: "Phone (Optional)",
      phonePlaceholder: "(555) 123-4567",
      message: "Message",
      messagePlaceholder: "How can we help you?",
      send: "Send Message",
      sending: "Sending...",
      successMessage: "Message sent successfully! We'll get back to you soon.",
    },
    // Footer
    footer: {
      tagline: "Making your events unforgettable with premium rental equipment.",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
  es: {
    // Navigation
    nav: {
      home: "Inicio",
      products: "Productos",
      booking: "Reservar",
      contact: "Contacto",
    },
    // Hero Section
    hero: {
      badge: "Alquiler de Equipos para Eventos",
      title: "Haz Tu Evento",
      titleHighlight: "Inolvidable",
      subtitle: "Sillas, mesas y castillos inflables de primera calidad para bodas, fiestas y eventos corporativos. Reserva fácil, servicio confiable.",
      browseBtn: "Ver Alquileres",
      contactBtn: "Contáctanos",
      startingFrom: "Desde",
      bestValue: "Mejor Valor",
    },
    // Features Section
    features: {
      title: "¿Por Qué Elegirnos?",
      subtitle: "Todo lo que necesitas para un evento exitoso",
      items: [
        { title: "Calidad Premium", description: "Equipos de primera categoría mantenidos con los más altos estándares para tus ocasiones especiales." },
        { title: "Reserva Fácil", description: "Reserva en línea simple con disponibilidad en tiempo real y confirmación instantánea." },
        { title: "Entrega Confiable", description: "Entrega y recogida puntual, para que puedas enfocarte en tu evento." },
      ],
    },
    // Equipment Section
    equipment: {
      title: "Nuestro Equipo",
      subtitle: "Todo lo que necesitas para un evento perfecto",
      viewAll: "Ver Todo",
      categories: {
        chairs: { title: "Sillas", description: "Opciones de asientos elegantes" },
        tables: { title: "Mesas", description: "Varios tamaños disponibles" },
        bouncy_castles: { title: "Castillos Inflables", description: "Diversión para todas las edades" },
      },
    },
    // How It Works Section
    howItWorks: {
      title: "Cómo Funciona",
      subtitle: "Pasos simples para tu evento perfecto",
      steps: [
        { step: "1", title: "Explora y Selecciona", description: "Explora nuestra colección y elige lo que necesitas" },
        { step: "2", title: "Elige tus Fechas", description: "Selecciona tu período de alquiler y verifica disponibilidad" },
        { step: "3", title: "Te lo Entregamos", description: "Llevamos todo a tu lugar a tiempo" },
      ],
    },
    // CTA Section
    cta: {
      title: "¿Listo para Hacer tu Evento Especial?",
      subtitle: "Explora nuestra selección y reserva hoy",
      button: "Comenzar Reserva",
    },
    // Products Page
    products: {
      title: "Nuestros Productos",
      subtitle: "Equipos de calidad para cada evento",
      allCategories: "Todos",
      chairs: "Sillas",
      tables: "Mesas",
      bouncyCastles: "Castillos Inflables",
      perDay: "/día",
      available: "disponibles",
      bookNow: "Reservar",
    },
    // Booking Page
    booking: {
      title: "Reserva tus Alquileres",
      subtitle: "Completa el formulario para solicitar tus artículos de alquiler",
      // Form sections
      rentalPeriod: "Período de Alquiler",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      selectItems: "Seleccionar Artículos",
      quantity: "Cant.",
      customerInfo: "Tu Información",
      name: "Nombre Completo",
      namePlaceholder: "Ingresa tu nombre completo",
      email: "Correo Electrónico",
      emailPlaceholder: "tu@correo.com",
      phone: "Número de Teléfono",
      phonePlaceholder: "(555) 123-4567",
      deliveryAddress: "Dirección de Entrega",
      deliveryAddressPlaceholder: "Ingresa la dirección completa de entrega",
      eventSchedule: "Horario del Evento",
      eventStart: "Hora de Inicio del Evento",
      eventEnd: "Hora de Fin del Evento",
      logistics: "Entrega y Recogida",
      earliestDelivery: "Hora Más Temprana de Entrega",
      latestPickup: "Hora Más Tardía de Recogida",
      specialRequests: "Solicitudes Especiales (Opcional)",
      specialRequestsPlaceholder: "Requisitos especiales o notas...",
      // Summary
      orderSummary: "Resumen del Pedido",
      rentalDays: "días",
      subtotal: "Subtotal",
      deliveryPickupFee: "Tarifa de Entrega/Recogida",
      total: "Total",
      submitBooking: "Enviar Solicitud de Reserva",
      // Messages
      selectDates: "Por favor selecciona las fechas de alquiler primero",
      noItemsSelected: "No hay artículos seleccionados",
      addItems: "Agrega artículos para ver precios",
      // Validation
      required: "Este campo es requerido",
      invalidEmail: "Por favor ingresa un correo válido",
      invalidPhone: "Por favor ingresa un teléfono válido",
      // Success
      successTitle: "¡Reserva Enviada!",
      successMessage: "Gracias por tu solicitud de reserva. La revisaremos y te contactaremos pronto por correo electrónico.",
      bookAnother: "Hacer Otra Reserva",
    },
    // Contact Page
    contact: {
      title: "Contáctanos",
      subtitle: "Nos encantaría saber de ti",
      getInTouch: "Ponte en Contacto",
      visitUs: "Visítanos",
      callUs: "Llámanos",
      emailUs: "Escríbenos",
      sendMessage: "Envíanos un Mensaje",
      name: "Tu Nombre",
      namePlaceholder: "Ingresa tu nombre",
      email: "Correo Electrónico",
      emailPlaceholder: "tu@correo.com",
      phone: "Teléfono (Opcional)",
      phonePlaceholder: "(555) 123-4567",
      message: "Mensaje",
      messagePlaceholder: "¿Cómo podemos ayudarte?",
      send: "Enviar Mensaje",
      sending: "Enviando...",
      successMessage: "¡Mensaje enviado exitosamente! Te contactaremos pronto.",
    },
    // Footer
    footer: {
      tagline: "Haciendo tus eventos inolvidables con equipos de alquiler premium.",
      quickLinks: "Enlaces Rápidos",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
    },
  },
};
